import { ShippingOptionErrorType } from '../../model'
import { useIsDeferredShipping, useIsPickup, useIsShippingAddressValid, useShippingOption } from '../../state'

interface ShippingAddressInlineLabels {
  heading: string
  description?: string
}

export const useShippingAddressInlineLabels = (): ShippingAddressInlineLabels => {
  const isPickup = useIsPickup()
  const isShippingAddressValid = useIsShippingAddressValid()

  if (!isShippingAddressValid) {
    return {
      heading: 'shippingAddress:noValidShippingAddress_inline.heading',
      description: 'shippingAddress:noValidShippingAddress_inline.description',
    }
  }

  return {
    heading: isPickup ? 'common:pickupFrom_inline' : 'common:shipTo',
  }
}

export const useShippingAddressInlineErrorKey = (): string | undefined => {
  const { error } = useShippingOption()
  const isShippingAddressValid = useIsShippingAddressValid()
  const isPickup = useIsPickup()
  const isDeferredShipping = useIsDeferredShipping()

  if (isShippingAddressValid && error === undefined) {
    return undefined
  }

  if (!isShippingAddressValid) {
    return 'shippingAddress:noChosenShippingAddressMessage.description_inline'
  } else if (error === ShippingOptionErrorType.ShippingAddressUnrecognised) {
    return 'shippingOption:error.shippingAddress.unrecognizedShippingAddress_inline'
  } else if (error === ShippingOptionErrorType.ShippingAddressUnsupported) {
    return 'shippingOption:error.shippingAddress.unsupportedShippingAddress_inline'
  } else if (!isPickup && error === ShippingOptionErrorType.ShippingAddressIncomplete) {
    return 'shippingOption:error.shippingAddress.incomplete_inline'
  } else if (error !== undefined && isDeferredShipping) {
    return 'shippingOption:error.default.message_inline'
  }
}
